
import { Component, Vue } from "vue-property-decorator";
import OrderNode from "@/views/financial/template/OrderNode.vue";
import {
  cancelOrderApi,
  confirmRecieve,
  getOrderInfoApp,
  PreRtnOrderInfoDto,
  purchaseGoodsAgain,
  ReturnOrderDtlDto,
  ShopOrderInfoDto,
  verifyReturnOrderDtl
} from "@/api/shopOrder";
import ServiceLine from "@/views/financial/template/ServiceLine.vue";
import { Action, Getter } from "vuex-class";
import AppendixName from "@/components/AppendixName/index.vue";
import { PreOrderListDto, PurchaseOrderDtlDto } from "@/api/buyCar";
import { getCompanyLine, ServiceLineListDto, upFile } from "@/api/commonConfig";
import { backToBefore, downFileToSystemFile } from "@/utils/h5ToApp";

@Component({
  name: "ShopOrderDetail",
  components: { OrderNode, ServiceLine, AppendixName }
})
export default class ShopOrderDetail extends Vue {
  @Getter companyId!: string;
  @Action setOrderDtlList!: (val: PreOrderListDto) => void;
  @Action setProviderId!: (val: string) => void;
  @Action setReturnOrderDtlList!: (val: PreRtnOrderInfoDto) => void;

  orderId = "";
  currRouteId = "";
  orderInfo: ShopOrderInfoDto = {};
  params: {
    orderId?: string;
    customerId?: string;
    companyId?: string;
    shopId?: string;
    currRouteId?: number;
  } = {};
  maxSize = 4 * 1024 * 1024;
  serviceLineList: ServiceLineListDto[] = [];
  fromPage = ""; // '1'为原生跳转过来的，返回上一页时调用原生返回

  activated() {
    if (this.$route.query.isRefresh) {
      this.getInfo();
    }
  }

  created() {
    this.fromPage = this.$route.query.fromPage as string;
    this.orderId = this.$route.query.orderId as string;
    this.currRouteId = this.$route.query.currRouteId as string;
    this.getInfo();
    // this.getServiceLine()
  }

  handleBack() {
    if (this.fromPage === "1") {
      backToBefore();
    } else {
      this.$router.back();
    }
  }

  getInfo() {
    const obj = {
      companyId: this.companyId,
      orderId: this.orderId,
      currRouteId: this.currRouteId
    };
    getOrderInfoApp(obj).then((res) => {
      this.orderInfo = res.data || {};
      this.params.orderId = this.orderInfo.orderId;
      this.params.customerId = this.companyId;
      this.params.companyId = this.companyId;
      this.params.shopId = this.orderInfo.shopCompanyId;
      this.params.currRouteId = this.orderInfo.currRouteId;

      this.getServiceLine(this.orderInfo.shopCompanyId);
    });
  }

  /* 跳转到店铺首页 */
  toShopHome() {
    this.setProviderId(this.orderInfo.shopCompanyId);
    this.$router.push({
      path: "/storeHome",
      query: { shopHomeTitle: this.orderInfo.shopCompanyName }
    });
  }

  /* 订单节点 */
  viewNode() {
    const data = {
      orderId: this.orderInfo.orderId,
      orderType: 1, // 1：订货单 2：退货单
      currRouteId: this.orderInfo.currRouteId
    };
    (this.$refs.orderNode as any).show(data);
  }

  /* 添加备注 */
  addRemark() {
    this.$router.push({
      path: "/addRemark",
      query: {
        orderId: this.orderInfo.orderId,
        orderType: "1",
        currRouteId: String(this.orderInfo.currRouteId)
      }
    });
  }

  /* 联系店家 */
  showServiceLine() {
    (this.$refs.serviceLine as any).show();
  }

  /**
   * 再次购买
   */
  buyAgain() {
    purchaseGoodsAgain(this.params)
      .then(() => {
        this.$toast.success("已添加至购物车");
      })
      .catch(() => {});
  }

  /**
   * 确认收货
   */
  confirmOrder() {
    confirmRecieve(this.params)
      .then((res) => {
        let msg = "";
        if (res.code === "000000") {
          msg = "确认收货成功";
        } else if (res.code === "000002") {
          msg = "订货单状态已变更";
        }
        this.$dialog
          .alert({
            message: msg
          })
          .then(() => {
            this.getInfo();
          });
      })
      .catch(() => {});
  }

  /* 取消订单 */
  cancelOrder() {
    cancelOrderApi(this.params).then((res) => {
      let msg = "";
      if (res.code === "000000") {
        msg = "取消订单成功";
      } else if (res.code === "000002") {
        msg = "订货单状态已变更，不可取消订单";
      }
      this.$dialog
        .alert({
          message: msg
        })
        .then(() => {
          this.getInfo();
        });
    });
  }

  /* 套餐清单 */
  toMerchBill(list: PurchaseOrderDtlDto[]) {
    const orderDtl = list.map((item) => {
      item.returnAmount = item.saleAmount;
      return item;
    });
    const data: PreRtnOrderInfoDto = {
      orderMoney: this.orderInfo.orderMoney,
      packageCateAmount: this.orderInfo.packageCateAmount,
      packageTotalQuantity: this.orderInfo.packageTotalQuantity,
      returnOrderDtlList: orderDtl as ReturnOrderDtlDto[]
    };
    this.setReturnOrderDtlList(data);
    this.$router.push({
      path: "/returnMerchBill",
      query: {
        isFreight: "1"
      }
    });
  }

  /* 下载附件 */
  // downloadFunc() {
  //   const data = {
  //     filePath: encodeURI(
  //       window.location.origin + this.$downloadUrl(this.orderInfo.orderFileUrl)
  //     ), // 完整的url地址
  //     fileName: this.orderInfo.orderFileName
  //   };
  //   downFileToSystemFile(data);
  //   // downloadFile({ filePath: this.orderInfo.orderFileUrl }).then((res: any) => {
  //   //     if (res instanceof ArrayBuffer) {
  //   //         exportFile(res, this.orderInfo.orderFileName)
  //   //         this.$toast('下载成功')
  //   //     } else {
  //   //         this.$toast('下载失败')
  //   //     }
  //   // })
  // }

  /* 获取服务热线 */
  getServiceLine(id: string) {
    getCompanyLine({ companyId: id }).then((res) => {
      this.serviceLineList = (res.data && res.data.serviceLineList) || [];
    });
  }

  /* 申请退货 */
  applyReturnGoods() {
    let arr = [];
    this.orderInfo.orderDtlList.forEach((item) => {
      if (item.returnSaleAmount) {
        arr.push({
          orderDtlId: item.orderDtlId,
          returnAmount: item.returnSaleAmount
        });
      }
    });
    if (arr && arr.length > 0) {
      const obj = {
        orderId: this.orderId,
        currRouteId: this.currRouteId,
        returnOrderDtlList: arr
      };
      verifyReturnOrderDtl(obj)
        .then((res) => {
          if (res.code === "000000") {
            const data = res.data;
            if (data && data.returnable) {
              this.$router.push({
                path: "/choosePackage",
                query: {
                  orderId: this.orderInfo.orderId,
                  currRouteId: String(this.orderInfo.currRouteId)
                }
              });
            } else {
              this.$toast.fail({
                message: "该订货单不可退货，请重新选择",
                duration: 1500,
                onClose: () => {
                  this.getInfo();
                }
              });
            }
          }
        })
        .catch(() => {});
    } else {
      this.$toast("此订单没有可退的商品");
    }
  }
}
